import styled from 'styled-components';


export const DepartmentsContainer = styled.div`
	display: flex;
	flex-direction: column;
  align-items: start;
	height: 100%;
	width: 100%;
	overflow: hidden;
	background-color: #f0f2f5;
  padding: 20px 80px;
`;

export const HeaderContainer = styled.div`
  padding: 16px 0;
  padding-bottom: 0px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
`;

export const DepartmentsContent = styled.div`
  display: flex;
  height: 80%;
  width: 100%;
  justify-content: space-between;
`;